import React from 'react';

import strings from '../../../Localization/Localization';

import { Container, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import '../../../css/tabs.css';
import '../../../css/tabs_order_mobile_support.css';

import MyForm from '../../Form/MyForm';
import { withModalHandler } from '../../../HOC/ModalHandler';

import { connect } from 'react-redux';
// import {
//   addLineToFlashbag,
//   FLASHBAG_TYPE_PRIMARY,
// } from '../../../Store/Action/flashbag';

import {
  registerMVNOService as register,
  newMVNOService as apiNew,
  newMVNOServiceWithPortability as apiNewWithPortability
} from '../../../API/MVNO';

import {
  updateCart as updateAlphalinkCart
} from '../../../API/AlphalinkMVNO';

import Table from '../../Table/Table';
import TableHeader from '../../Table/TableHeader';
import TableBody from '../../Table/TableBody';
import TableTextHeader from '../../Table/Header/TableTextHeader';
import TableRowWithCollapse from '../../Table/Body/TableRowWithCollapse';
// import TableRowCollapsedElement from '../../Table/Body/TableRowCollapsedElement';
// import TableRowCollapsedRow from '../../Table/Body/TableRowCollapsedRow';

import StringCell from '../../Form/Field/TableCell/StringCell';
import SwitchCell from '../../Form/Field/TableCell/SwitchCell';
import DropdownCell from '../../Form/Field/TableCell/DropdownCell';
import DateCell from '../../Form/Field/TableCell/DateCell';

import SubFooter from '../../Layout/SubFooter';

import Loading from '../../Layout/Loading';

/**
 * OrderMobileSupportTab
 *
 * This component managed a entity tab with a form
 */
class OrderMobileSupportTab extends React.Component {

  static defaultProps = {
    onUpdateItem: (data) => {},
  }

  constructor(props) {
    super(props);

    //state of the component, including :
    // - preLoading : if the data is actually preLoading
    // - item : the item
    this.state = {
      preLoading: true,
      preLoadingError: false,
      postLoading: false,

      item: null,

      mobileServices: []
    }

    this.getFromId = this.props.modalHandler.addVerificationWithCallback(props.apiGet, this.updateItem, this.updateItemFailure);

    this.updateAlphalinkCart = this.props.modalHandler.addVerificationWithCallback(updateAlphalinkCart, this.postUpdateAlphalinkCart, this.postUpdateAlphalinkCartFailure);

    this.register = (value) => this.props.modalHandler.addVerificationWithCallback(register, (data) => this.postRegister(value, data), (msg) => this.postRegisterFailure(value, msg));
    this.apiNew = (value) => this.props.modalHandler.addVerification(this.props.modalHandler.addVerificationWithCallback(apiNew, (data) => this.postApiNew(value, data), (msg) => this.postApiNewFailure(value, msg)));
    this.apiNewWithPortability = (value) => this.props.modalHandler.addVerification(this.props.modalHandler.addVerificationWithCallback(apiNewWithPortability,  (data) => this.postApiNewWithPortability(value, data), (msg) => this.postApiNewWithPortabilityFailure(value, msg)));
  }

  /**
   * Once the component is mounted, we can query for the information of the item
   * needed to be displayed in the component
   */
  componentDidMount() {
    this.getFromId(this.props.entityId);
  }

  /**
   * callback that collect the data from the fetch call and update the item
   *
   * @param data data from the fetch call
   */
  updateItem = (data) => {
    this.props.onUpdateItem(data);
    this.setState({
      preLoading: false,
      preLoadingError: false,
      item: data.item,
    })
  }

  updateItemFailure = (msg) => {
    this.setState({
      preLoading: false,
      preLoadingError: true
    })
  }

  postUpdateAlphalinkCart = (data) => {
    if(data.result) {
      this.props.changeTab(this.props.eventKey)
    }
  }

  postUpdateAlphalinkCartFailure = (msg) => {
    console.log(msg);
  }


  postRegister = (value, data) => {
    let newValues = this.state.mobileServices.find(mobileService => mobileService && mobileService.id === value.id);
    newValues.loading = false;

    if(data.result === true) {
      newValues.state = "not_created";
    }

    let mobileServices = [...this.state.mobileServices];
    mobileServices[newValues.id] = newValues;

    this.setState({
      mobileServices: mobileServices
    })
  }

  postRegisterFailure = (value, msg) => {
    console.log(value, msg);
  }

  postApiNew = (value, data) => {
    let newValues = this.state.mobileServices.find(mobileService => mobileService && mobileService.id === value.id);
    newValues.loading = false;

    if(data.result === true) {
      newValues.state = data["order_state"];
    }

    let mobileServices = [...this.state.mobileServices];
    mobileServices[newValues.id] = newValues;

    this.setState({
      mobileServices: mobileServices
    })
  }

  postApiNewFailure = (value, msg) => {
    console.log(value, msg);
    // this.setState({
    //
    // })
  }

  postApiNewWithPortability = (value, data) => {
    let newValues = this.state.mobileServices.find(mobileService => mobileService && mobileService.id === value.id);
    newValues.loading = false;

    if(data.result === true) {
      newValues.state = data["order_state"];
    }

    let mobileServices = [...this.state.mobileServices];
    mobileServices[newValues.id] = newValues;

    this.setState({
      mobileServices: mobileServices
    })
  }

  postApiNewWithPortabilityFailure = (value, msg) => {
    console.log(value, msg);
    // this.setState({
    //
    // })
  }

  isEditable() {
    return this.props.editable && this.props.entity.cart.state === "o_d_i_progress"
  }

  computeHeaders() {
    let editableStatus = ["not_initialised", "not_created", "canceled"];
    return [
      {
        label: (
          <OverlayTrigger
            placement="right"
            overlay={
              <Tooltip>Informations sur la validité</Tooltip>
            }>
            <div className="d-flex justify-content-center item-index-status item-index-status-info-icon"><i className="icon-info"/></div>
          </OverlayTrigger>
        ),
        value: (item) => {
          if(item.selected) {
            let errors = this.getErrors(item);
            if(errors.length === 0) {
              return (
                <OverlayTrigger
                  placement="right"
                  overlay={
                    <Tooltip>OK</Tooltip>
                  }>
                  <div className="d-flex justify-content-center item-index-status item-index-status-validated-icon"><i className="icon-checkmark"/></div>
                </OverlayTrigger>
              );
            }
            else {
              return (
                <OverlayTrigger
                  placement="right"
                  overlay={
                    <Tooltip><>{errors.map(error => {
                      return (
                        <>
                          {error}
                          <br/>
                        </>
                      )
                    })}</></Tooltip>
                  }>
                  <div className="d-flex justify-content-center item-index-status item-index-status-danger-icon"><i className="icon-warning"/></div>
                </OverlayTrigger>
              );
            }
          }
          return null;
        },
      },
      {
        value: "selected",
        label: (
          <OverlayTrigger
            placement="right"
            overlay={
              <Tooltip>Selectionné</Tooltip>
            }>
            <div className="d-flex item-index-status item-index-status-info-icon tabs-order-mobile-support-table-icon"><i className="icon-toggles"/></div>
          </OverlayTrigger>
        ),
        type: "switch",
        additionalConfiguration: (values) => {
          return {
            editable: this.isEditable() && editableStatus.includes(values.state),
            onChange: (row, fieldKey, value) => this.onChangeValue(values, row, fieldKey, value)
          }
        }
      },
      {
        value: "mvno_product",
        label: "Produit",
        type: "dropdown",
        additionalConfiguration: (values) => {
          return {
            editable: values.selected,
            onChange: (row, fieldKey, value) => this.onChangeValue(values, row, fieldKey, value),
            fieldList: values.productFieldList
          }
        }
      },
      {
        value: "portability",
        label: (
          <OverlayTrigger
            placement="right"
            overlay={
              <Tooltip>Portabilité ?</Tooltip>
            }>
            <div className="d-flex item-index-status item-index-status-info-icon tabs-order-mobile-support-table-icon"><i className="icon-send"/></div>
          </OverlayTrigger>
        ),
        type: "switch",
        additionalConfiguration: (values) => {
          return {
            editable: values.selected,
            onChange: (row, fieldKey, value) => this.onChangeValue(values, row, fieldKey, value)
          }
        }
      },
      {
        value: "number",
        label: "Numéro",
        type: "string",
        additionalConfiguration: (values) => {
          return {
            editable: values.selected && values.portability,
            onChange: (row, fieldKey, value) => this.onChangeValue(values, row, fieldKey, value)
          }
        }
      },
      {
        value: "rio",
        label: "RIO",
        type: "string",
        additionalConfiguration: (values) => {
          return {
            editable: values.selected && values.portability,
            onChange: (row, fieldKey, value) => this.onChangeValue(values, row, fieldKey, value)
          }
        }
      },
      {
        value: "esim",
        label: (
          <OverlayTrigger
            placement="right"
            overlay={
              <Tooltip>eSIM ?</Tooltip>
            }>
            <div className="d-flex item-index-status item-index-status-info-icon tabs-order-mobile-support-table-icon"><i className="icon-sim"/></div>
          </OverlayTrigger>
        ),
        type: "switch",
        additionalConfiguration: (values) => {
          return {
            editable: values.selected,
            onChange: (row, fieldKey, value) => this.onChangeValue(values, row, fieldKey, value)
          }
        }
      },
      {
        value: "sim_number",
        label: "Carte SIM",
        type: "string",
        additionalConfiguration: (values) => {
          return {
            editable: values.selected && !values.esim,
            onChange: (row, fieldKey, value) => this.onChangeValue(values, row, fieldKey, value)
          }
        }
      },
      {
        value: "contact_mail",
        label: "Mail (eSim)",
        type: "string",
        additionalConfiguration: (values) => {
          return {
            editable: values.selected && values.esim,
            onChange: (row, fieldKey, value) => this.onChangeValue(values, row, fieldKey, value)
          }
        }
      },
      {
        value: "date",
        label: "Date effective",
        type: "date",
        additionalConfiguration: (values) => {
          let today = new Date();

          let minDate = new Date(today);
          if(values.portability === true) {
            minDate.setDate(today.getDate()+5);
          }
          else {
            minDate.setDate(today.getDate()-1);
          }

          let maxDate = new Date(today);
          maxDate.setDate(today.getDate()+30);

          return {
            min: `${minDate.getFullYear()}-${(minDate.getMonth()+1).toString().padStart(2,"0")}-${(minDate.getDate()+1).toString().padStart(2,"0")}`,
            max: `${maxDate.getFullYear()}-${(maxDate.getMonth()+1).toString().padStart(2,"0")}-${(maxDate.getDate()+1).toString().padStart(2,"0")}`,
            editable: values.selected,
            onChange: (row, fieldKey, value) => this.onChangeValue(values, row, fieldKey, value)
          }
        }
      },
      {
        value: item => {
          if(item.loading) {
            return <span><Loading container="parent" size="small"/></span>
          }
          return strings.order.mobileSupport.tab.status.values[item.state]
        },
        label: strings.order.mobileSupport.tab.status.label
      }
    ];
  }

  computeValues() {
    if(!this.state.item) {
      return [];
    }

    let values = [];

    this.state.item.cart["cart_items"].forEach((cartItem, i) => {
      let startingIndex = values.length;
      if(
        cartItem.product["product_sub_family"]["phone_package_mvno"] === true
        && (cartItem.product["alphalink_mobile_products"].length + cartItem.product["transatel_mobile_products"].length) > 0
      ) {
        let fieldList = [];
        cartItem.product["alphalink_mobile_products"].forEach((alphalinkMobileProduct) => {
          fieldList.push({
            id: alphalinkMobileProduct.id,
            subtype: "alphalink",
            value: alphalinkMobileProduct.name,
            label: "A - "+alphalinkMobileProduct.name
          })
        });
        cartItem.product["transatel_mobile_products"].forEach((transatelMobileProduct) => {
          fieldList.push({
            id: transatelMobileProduct.id,
            subtype: "transatel",
            value: transatelMobileProduct.name,
            label: "T - "+transatelMobileProduct.name
          })
        });

        for (let j = 0; j < cartItem.quantity; j++) {
          if(this.state.mobileServices[startingIndex+j]) {
            values.push(this.state.mobileServices[startingIndex+j])
          }
          else if(cartItem["alphalink_mobile_services"].some(alphalinkMobileService => alphalinkMobileService["cart_item_intern_id"] === j)) {
            let alphalinkMobileService = cartItem["alphalink_mobile_services"].find(alphalinkMobileService => alphalinkMobileService["cart_item_intern_id"] === j);
            values.push({
              id: startingIndex+j,
              cart_item_id: cartItem.id,
              cart_item_intern_id: j,
              subtype: "alphalink",
              subid: i,
              selected: false,
              portability: alphalinkMobileService.portability,
              mvno_product: alphalinkMobileService["alphalink_mobile_product"].name,
              number: alphalinkMobileService.number,
              rio: alphalinkMobileService.rio,
              esim: alphalinkMobileService.esim,
              sim_number: alphalinkMobileService["sim_number"],
              contact_mail: alphalinkMobileService.mail,
              date: alphalinkMobileService.date,
              state: alphalinkMobileService["alphalink_state"],
              loading: false,

              productFieldList: fieldList
            })
          }
          else if(cartItem["transatel_mobile_services"].some(transatelMobileService => transatelMobileService["cart_item_intern_id"] === j)) {
            let transatelMobileService = cartItem["transatel_mobile_services"].find(transatelMobileService => transatelMobileService["cart_item_intern_id"] === j);
            values.push({
              id: startingIndex+j,
              cart_item_id: cartItem.id,
              cart_item_intern_id: j,
              subtype: "transatel",
              subid: i,
              selected: false,
              portability: transatelMobileService.portability,
              mvno_product: transatelMobileService["transatel_mobile_product"].name,
              number: transatelMobileService.number,
              rio: transatelMobileService.rio,
              esim: transatelMobileService.esim,
              sim_number: transatelMobileService["sim_number"],
              contact_mail: transatelMobileService.mail,
              date: transatelMobileService.date,
              state: transatelMobileService["transatel_state"],
              loading: false,

              productFieldList: fieldList
            })
          }
          else {
            values.push({
              id: startingIndex+j,
              cart_item_id: cartItem.id,
              cart_item_intern_id: j,
              subtype: "none",
              selected: false,
              portability: false,
              mvno_product: "",
              number: "",
              rio: "",
              esim: false,
              sim_number: "",
              contact_mail: "",
              date: "",
              state: "not_initialised",
              loading: false,

              productFieldList: fieldList
            })
          }
        }
      }
    });

    return values;
  }

  onChangeValue = (values, row, fieldKey, value) => {
    let newValues = {};
    if(this.state.mobileServices[values.id]) {
      Object.assign(newValues, this.state.mobileServices[values.id])
    }
    else {
      Object.assign(newValues, values)
    }
    newValues[fieldKey] = value;

    let mobileServices = [...this.state.mobileServices];
    mobileServices[row] = newValues;
    this.setState({
      mobileServices: mobileServices
    });
  }

  checkValidity = (mobileService) => {
    if(mobileService.selected === false) {
      return false;
    }

    if(!mobileService.productFieldList.find((product) => product.value === mobileService["mvno_product"])) {
      return false;
    }

    const mobileRegex = /^0[67][\d]{8}$/;
    const rioRegex = /^[0-9a-zA-Z\+]{12}$/;
    // const rioRegex = /^[\d\+]{2}[PE\+][0-9a-zA-Z\+]{6}[0-9a-zA-Z\+]{3}$/;
    if(mobileService.protability === true && (!mobileRegex.test(mobileService.number) || !rioRegex.test(mobileService.rio))) {
      return false;
    }

    const contactMailRegex = /^.+@.+\..+$/;
    const simNumberRegex = /^[0-9]{13}$/;
    if((mobileService.esim === true && !contactMailRegex.test(mobileService["contact_mail"]))
      || (mobileService.esim === false && !simNumberRegex.test(mobileService["sim_number"]))
    ) {
      return false;
    }

    const parsed_date = Date.parse(mobileService.date);
    if(!Number.isNaN(parsed_date)) {
      const today = new Date();
      const date = new Date(parsed_date);

      const diffTime = date - today;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if((mobileService.portability === true && diffDays < 5) || (mobileService.portability === false && diffDays < 0)) {
        return false
      }
    }
    else {
      return false;
    }

    if(mobileService.subtype === "alphalink" && !this.getAlphalinkStatus()) {
      return false;
    }
    else if(mobileService.subtype === "transatel" && !this.getTransatelStatus()) {
      return false;
    }

    return true;
  }

  getErrors = (mobileService) => {
    if(mobileService.selected === false) {
      return false;
    }

    let errors = [];

    if(!mobileService.productFieldList.find((product) => product.value === mobileService["mvno_product"])) {
      errors.push("Produit non selectionné");
    }

    const mobileRegex = /^0[67][\d]{8}$/;
    const rioRegex = /^[0-9a-zA-Z\+]{12}$/;
    // const rioRegex = /^[\d\+]{2}[PE\+][0-9a-zA-Z\+]{6}[0-9a-zA-Z\+]{3}$/;
    if(mobileService.portability === true && !rioRegex.test(mobileService.rio)) {
      errors.push("Le RIO n'est pas conforme");
    }
    if(mobileService.portability === true && !mobileRegex.test(mobileService.number)) {
      errors.push("Le numéro n'est pas conforme");
    }

    const contactMailRegex = /^.+@.+\..+$/;
    const simNumberRegex = /^[0-9]{13}$/;
    if(mobileService.esim === true && !contactMailRegex.test(mobileService["contact_mail"])) {
      errors.push("L'option eSIM est selectionné, et le mail de contact n'est pas rempli");
    }
    if(mobileService.esim === false && !simNumberRegex.test(mobileService["sim_number"])) {
      errors.push("Le numéro de SIM n'est pas conforme");
    }

    const parsed_date = Date.parse(mobileService.date);
    if(!Number.isNaN(parsed_date)) {
      const today = new Date();
      const date = new Date(parsed_date);

      const diffTime = date - today;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if((mobileService.portability === true && diffDays < 5) || (mobileService.portability === false && diffDays < 0)) {
        errors.push("Le date n'est pas correcte");
      }
    }
    else {
      errors.push("Le date n'est pas correcte");
    }

    if(mobileService.subtype === "alphalink" && !this.getAlphalinkStatus()) {
      errors.push("Alphalink n'est pas configuré pour ce client");
    }
    else if(mobileService.subtype === "transatel" && !this.getTransatelStatus()) {
      errors.push("Transatel n'est pas configuré pour ce client");
    }

    return errors;
  }

  getTransatelStatus = () => {
    return true;
  }

  getAlphalinkStatus = () => {
    return this.state.item && this.state.item.cart && this.state.item.cart.client && this.state.item.cart.client.partner && this.state.item.cart.client.partner["alphalink_client_account"] && this.state.item.cart.client.partner["alphalink_client_account"]["id"] && this.state.item.cart.place && this.state.item.cart.place["alphalink_place"] && this.state.item.cart.place["alphalink_place"]["id"];
  }

  registerOrders = (values) => {
    let mobileServices = [...this.state.mobileServices];
    let requests = [];

    values.forEach((value) => {
      if(this.checkValidity(value)) {
        let newValues = Object.assign({}, this.state.mobileServices[value.id])
        newValues.selected = false;
        newValues.loading = true;

        let product = value.productFieldList.find((product) => product.value === value["mvno_product"]);

        requests.push({
          value: value,
          mvno: product.subtype,
          params: {
            cart_id: this.state.item.cart.id,
            cart_item_id: value.cart_item_id,
            cart_item_intern_id: value.cart_item_intern_id,
            mobile_product_id: product.id,
            number: value.number,
            rio: value.rio,
            sim_number: value.sim_number,
            mail: value.contact_mail,
            date: value.date,
            esim: value.esim,
            portability: value.portability
          }
        })

        mobileServices[value.id] = newValues;
      }
    });

    this.setState({
      mobileServices: mobileServices
    }, () => {
      requests.forEach((request) => {
        (this.register(request.value))(request.mvno, request.params);
      });
    });
  }

  updateCart = () => {
    if(!this.state.loading) {
      this.updateAlphalinkCart(this.state.item.cart.id)
    }
  }

  startOrders = (values) => {
    let mobileServices = [...this.state.mobileServices];
    let requests = [];

    values.forEach((value) => {
      if(this.checkValidity(value)) {
        let newValues = Object.assign({}, this.state.mobileServices[value.id])
        newValues.selected = false;
        newValues.loading = true;

        let product = value.productFieldList.find((product) => product.value === value["mvno_product"]);

        requests.push({
          value: value,
          mvno: product.subtype,
          portability: value.portability,
          params: {
            cart_id: this.state.item.cart.id,
            cart_item_id: value.cart_item_id,
            cart_item_intern_id: value.cart_item_intern_id,
            mobile_product_id: product.id,
            number: value.number,
            rio: value.rio,
            sim_number: value.sim_number,
            mail: value.contact_mail,
            date: value.date,
            esim: value.esim,
            portability: value.portability
          }
        })

        mobileServices[value.id] = newValues;
      }
    });

    this.setState({
      mobileServices: mobileServices
    }, () => {
      requests.forEach((request) => {
        if(request.portability) {
          (this.apiNewWithPortability(request.value))(request.mvno, request.params);
        }
        else {
          (this.apiNew(request.value))(request.mvno, request.params);
        }
      });
    });
  }

  displayLoading() {
    if(this.state.preLoading || this.state.postLoading) {
      return (
        <Loading/>
      )
    }
  }

  displayAvailability() {
    const values = {
      alphalink: this.getAlphalinkStatus(),
      transatel: this.getTransatelStatus()
    }

    const fields = [
      {
        fieldKey: "alphalink",
        type: "switch",
        label: "Alphalink",
        disabled: true,
        showOnDisabled: () => true,
        validators: []
      },
      {
        fieldKey: "transatel",
        type: "switch",
        label: "Transatel",
        disabled: true,
        showOnDisabled: () => true,
        validators: []
      }
    ]

    return (
      <MyForm
        formKey="mvno_validity"
        fields={fields}
        extraValues={{}}
        disabled={true}
        values={values}
        displaySubmitButton={false}

        numberColumn={2}
        formSizeMd={8}
      />
    )
  }

  displayTable(values) {
    if(!this.state.preLoading && !this.state.preLoadingError) {
      let headers = this.computeHeaders();

      return (
        <Table
          className="tabs-order-mobile-support-table"
          cellCollection={{
            string: StringCell,
            switch: SwitchCell,
            dropdown: DropdownCell,
            date: DateCell
          }}>
          <TableHeader sticky={true}>
            {headers
              .map((header, i) => {
                return <TableTextHeader key={i} value={header.value} label={header.label} type={header.type} additionalConfiguration={header.additionalConfiguration}/>
              }
            )}
          </TableHeader>
          <TableBody>
            {values.map((item) => {
              return (
                <TableRowWithCollapse
                  key={item.id}
                  className="row-my-primary"
                  entityPath={() => "#"}
                  data={item}>
                </TableRowWithCollapse>
              )
            })}
          </TableBody>
        </Table>
      )
    }
  }

  displayButtons(values) {
    let disabled = !this.isEditable() || !values.some((value) => value.selected);
    return (
      <SubFooter>
        <Button variant="my-information" className="btn-sub-footer"  onClick={() => this.registerOrders(values)} disabled={disabled}><i className="icon-pen"/>&nbsp;Enregistrer les informations</Button>
        <Button variant="my-information" className="btn-sub-footer"  onClick={() => this.updateCart()}>MàJ des statuts</Button>
        <Button variant="my-information" className="btn-sub-footer"  onClick={() => this.startOrders(values)} disabled={disabled}><i className="icon-pen"/>&nbsp;Lancer les commandes</Button>
      </SubFooter>
    )
  }

  /**
   * Main render method for React Component
   */
  render() {
    let values = this.computeValues();
    return (
      <>
        {this.displayLoading()}
        <Container className="d-flex flex-column align-items-center">
          {this.displayAvailability()}
          {this.displayTable(values)}
        </Container>
        {this.displayButtons(values)}
      </>
    );
  }
}

export default connect()(withModalHandler(OrderMobileSupportTab));
